// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PublicationItem_publication__UpLKh {
  margin-bottom: 25px;
}
.PublicationItem_publication__UpLKh .PublicationItem_title__-tVIM {
  font-size: 13px;
  margin-bottom: 10px;
}
.PublicationItem_publication__UpLKh .PublicationItem_title__-tVIM .PublicationItem_paper-title__YZ9wJ {
  font-weight: 600;
}
.PublicationItem_publication__UpLKh .PublicationItem_title__-tVIM .PublicationItem_paper-title__YZ9wJ a {
  color: var(--blue);
  text-decoration: none;
  transition: all 0.2s ease;
}
.PublicationItem_publication__UpLKh .PublicationItem_title__-tVIM .PublicationItem_paper-title__YZ9wJ:not(.PublicationItem_clickable__cm5w6) a {
  cursor: default;
}
.PublicationItem_publication__UpLKh .PublicationItem_title__-tVIM .PublicationItem_paper-title__YZ9wJ:not(.PublicationItem_clickable__cm5w6) a:hover {
  color: var(--blue);
}
.PublicationItem_publication__UpLKh .PublicationItem_title__-tVIM .PublicationItem_paper-title__YZ9wJ.PublicationItem_clickable__cm5w6:hover a {
  cursor: pointer;
  text-decoration: underline;
  color: rgb(from var(--blue) r g b/50%) !important;
}
.PublicationItem_publication__UpLKh .PublicationItem_title__-tVIM .PublicationItem_venue__VLqWO {
  font-style: italic;
}
.PublicationItem_publication__UpLKh .PublicationItem_coauthors__h2fEc {
  margin-bottom: 8px;
  color: var(--grey-text);
  font-size: 12px;
}
.PublicationItem_publication__UpLKh .PublicationItem_coauthors__h2fEc p {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.PublicationItem_publication__UpLKh .PublicationItem_coauthors__h2fEc span {
  font-style: italic;
}
.PublicationItem_publication__UpLKh .PublicationItem_coauthors__h2fEc span:not(:last-child)::after {
  content: ", ";
}
.PublicationItem_publication__UpLKh .PublicationItem_action__BP-4s {
  margin-top: 4px;
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/PublicationItem/PublicationItem.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AACE;EACE,eAAA;EACA,mBAAA;AACJ;AACI;EACE,gBAAA;AACN;AACM;EACE,kBAAA;EACA,qBAAA;EACA,yBAAA;AACR;AAGQ;EACE,eAAA;AADV;AAGU;EACE,kBAAA;AADZ;AAOQ;EACE,eAAA;EACA,0BAAA;EACA,iDAAA;AALV;AAUI;EACE,kBAAA;AARN;AAYE;EACE,kBAAA;EACA,uBAAA;EACA,eAAA;AAVJ;AAYI;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAVN;AAaI;EACE,kBAAA;AAXN;AAcQ;EACE,aAAA;AAZV;AAkBE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;AAhBJ","sourcesContent":[".publication {\n  margin-bottom: 25px;\n\n  .title {\n    font-size: 13px;\n    margin-bottom: 10px;\n\n    .paper-title {\n      font-weight: 600;\n\n      a {\n        color: var(--blue);\n        text-decoration: none;\n        transition: all 0.2s ease;\n      }\n\n      &:not(.clickable) {\n        a {\n          cursor: default;\n\n          &:hover {\n            color: var(--blue);\n          }\n        }\n      }\n\n      &.clickable:hover {\n        a {\n          cursor: pointer;\n          text-decoration: underline;\n          color: rgb(from var(--blue) r g b / 50%) !important;\n        }\n      }\n    }\n\n    .venue {\n      font-style: italic;\n    }\n  }\n\n  .coauthors {\n    margin-bottom: 8px;\n    color: var(--grey-text);\n    font-size: 12px;\n\n    p {\n      display: -webkit-box;\n      -webkit-line-clamp: 3;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n    }\n\n    span {\n      font-style: italic;\n\n      &:not(:last-child) {\n        &::after {\n          content: \", \";\n        }\n      }\n    }\n  }\n\n  .action {\n    margin-top: 4px;\n    display: flex;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"publication": `PublicationItem_publication__UpLKh`,
	"title": `PublicationItem_title__-tVIM`,
	"paper-title": `PublicationItem_paper-title__YZ9wJ`,
	"clickable": `PublicationItem_clickable__cm5w6`,
	"venue": `PublicationItem_venue__VLqWO`,
	"coauthors": `PublicationItem_coauthors__h2fEc`,
	"action": `PublicationItem_action__BP-4s`
};
export default ___CSS_LOADER_EXPORT___;
